export const ONBOARDING_OBJECTIVE = {
  planProjects: 'plan_projects',
  visibility: 'visibility',
  resources: 'resources',
} as const

export type OnboardingObjective =
  (typeof ONBOARDING_OBJECTIVE)[keyof typeof ONBOARDING_OBJECTIVE]

export const ONBOARDING_START_MODE = {
  import: 'import',
  scratch: 'scratch',
  demo: 'demo',
} as const

export type OnboardingStartMode =
  (typeof ONBOARDING_START_MODE)[keyof typeof ONBOARDING_START_MODE]

export const ONBOARDING_COLLABORATION_MODE = {
  solo: 'solo',
  team: 'team',
} as const

export type OnboardingCollaborationMode =
  (typeof ONBOARDING_COLLABORATION_MODE)[keyof typeof ONBOARDING_COLLABORATION_MODE]

export const ONBOARDING_STATUS = {
  inProgress: 'in_progress',
  complete: 'complete',
  skipped: 'skipped',
} as const

export type OnboardingStatus =
  (typeof ONBOARDING_STATUS)[keyof typeof ONBOARDING_STATUS]

export type OnboardingCreatedEntities = {
  organizationId?: string
  projectId?: string
  placeId?: string
  shopId?: string
  demoProductId?: string
  demoProductRootId?: string
}

export type OnboardingPreferencePayload = {
  status: OnboardingStatus
  invitationOrganizationId?: string
  objective?: OnboardingObjective
  startMode?: OnboardingStartMode
  collaborationMode?: OnboardingCollaborationMode
  defaultSaleStatus?: boolean
  createdEntities?: OnboardingCreatedEntities
  completedAt?: string
}

export type OnboardingSurveyProfile = {
  userType?: string
  userUsage?: string[]
  userJob?: string
  userTeamSize?: string
  userJobBrevoId?: number
}

export type OnboardingDraft = {
  invitationOrganizationId?: string
  surveyProfile?: OnboardingSurveyProfile
  objective?: OnboardingObjective
  teamName?: string
  projectName?: string
  placeName?: string
  projectType?: { label: string; value: string }
  address?: {
    label: string
    address: string
    city: string
    zipcode: string
    country: string
    location?: { lat: number; lon: number }
  }
  shopName?: string
  shopSlug?: string
  shopLogoUrl?: string
  inviteEmail?: string
  inviteName?: string
  startMode?: OnboardingStartMode
  collaborationMode?: OnboardingCollaborationMode
  defaultSaleStatus?: boolean
  createdEntities: OnboardingCreatedEntities
}

export const ONBOARDING_STEP = {
  welcome: 'welcome',
  invitation: 'invitation',
  profile: 'profile',
  profileTeamSize: 'profile_team_size',
  job: 'job',
  usage: 'usage',
  objective: 'objective',
  teamName: 'team_name',
  teamMembers: 'team_members',
  projectPlace: 'project_place',
  shopName: 'shop_name',
  shopInvite: 'shop_invite',
  saleStatus: 'sale_status',
  resourceStart: 'resource_start',
  resourceTeam: 'resource_team',
  final: 'final',
} as const

export type OnboardingStepId =
  (typeof ONBOARDING_STEP)[keyof typeof ONBOARDING_STEP]

export type OnboardingFinalCta = {
  id: string
  href: string
  labelKey: string
  variant: 'primary' | 'secondary'
}
